import { easing as easingProgress } from 'easing-progress';
export { EaseInBack, EaseInBounce, EaseInCirc, EaseInCubic, EaseInElastic, EaseInExpo, EaseInOutBack, EaseInOutBounce, EaseInOutCirc, EaseInOutCubic, EaseInOutElastic, EaseInOutExpo, EaseInOutQuad, EaseInOutQuart, EaseInOutQuint, EaseInOutSine, EaseInQuad, EaseInQuart, EaseInQuint, EaseInSine, EaseOutBack, EaseOutBounce, EaseOutCirc, EaseOutCubic, EaseOutElastic, EaseOutExpo, EaseOutQuad, EaseOutQuart, EaseOutQuint, EaseOutSine, } from 'easing-progress';
/**
 * Easing progress
 *
 * @example
 *
 * easing(0.35, EaseInBounce); // => 0.167
 * easing(0.35, [.25, .1, .25, 1]); // => 0.604
 * easing(0.35, (value) => Math.sin(Math.PI * 0.5 * value)); // => 0.522
 */
export const easing = (progress, easingType) => { var _a, _b; if (easingType === void 0) { easingType = (_b = (_a = window.vevetApp) === null || _a === void 0 ? void 0 : _a.props.easing) !== null && _b !== void 0 ? _b : false; } return easingProgress(progress, easingType); };
//# sourceMappingURL=easing.js.map